// isEquipmentRestricted.ts
type EquipmentRestrictionParams = {
  type: "delivery_trap" | "delivery_route";
  status: string;
  doorId?: number | null;
  trailerId?: number | null;
  straightTruckId?: number | null;
};

export const isEquipmentRestricted = ({
  type,
  status,
  doorId,
  trailerId,
  straightTruckId,
}: EquipmentRestrictionParams): {
  restricted: boolean;
  missingEquipment?: string;
} => {
  const isRestrictedStatus = ["CLDK", "CLDV", "DISP", "TRAP"].includes(status);

  const equipment =
    type === "delivery_trap"
      ? [
          { key: "Door", value: !doorId },
          {
            key: "Trailer / Straight Truck",
            value: !trailerId && !straightTruckId,
          },
        ]
      : [{ key: "Door", value: !doorId }];

  const missingEquipment = equipment.find((equip) => equip.value)?.key;

  if (isRestrictedStatus && missingEquipment) {
    return { restricted: true, missingEquipment };
  }

  return { restricted: false };
};
